import { pm2ConfigStore } from '@pm2/store';
import { useNotifier } from '@provider/notifier';
import { userIdentityManager } from '@provider/user-identity';
import { KeyIcon } from '@ui/kit/icons';
import { jsxs, jsx } from 'react/jsx-runtime';

function useLoginPrompt() {
  const notifier = useNotifier();
  const trialAccessUrl = pm2ConfigStore.useSelector(state => state.config.settings.trialAccessUrl);
  const onClick = async () => {
    const actions = [{
      intent: "login",
      type: "primary",
      label: /*#__PURE__*/jsxs("span", {
        className: promptButtonWrapperCls,
        children: [/*#__PURE__*/jsx(KeyIcon, {
          height: 20
        }), " Log ind"]
      })
    }];
    if (trialAccessUrl) {
      actions.unshift({
        intent: "trial-access",
        type: "secondary",
        label: "Bestil prøveadgang"
      });
    }
    const result = await notifier.dialog({
      heading: "Du er ikke logget ind!",
      body: "Du skal være logget ind, for at kunne tilgå materialet.",
      actions
    });
    switch (result) {
      case "login":
        userIdentityManager.requestLogin();
        break;
      case "trial-access":
        if (trialAccessUrl) {
          window.open(trialAccessUrl, "_blank");
        }
        break;
    }
  };
  return onClick;
}
const promptButtonWrapperCls = "_yr2p1yoli1s";

export { useLoginPrompt };
import "./login-prompt.linaria.module.css";
//# sourceMappingURL=login-prompt.js.map
